// import React from "react";
import React, { useState} from "react";
import { useNavigate, Link } from "react-router-dom";
import { loadPermissions } from "../utils/permission";

function Login(){
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

      const email = e.target.inputEmailAddress.value;
      const password = e.target.inputChoosePassword.value;

      try {
        // const res = await fetch("https://backend.macustore.com/api/v1/auth/login", {
        const res = await fetch("https://backend.suvidhape.in/api/v1/auth/login", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email_or_mobile: email,
            password: password,
          }),
        });

        if (!res.ok) {
          const errData = await res.json();
          throw new Error(errData.detail || "Login failed");
        }

        const data = await res.json();
        localStorage.setItem("token", data.access_token);
        localStorage.setItem("user", JSON.stringify(data.user));
        await loadPermissions(data.user.id); 
        setTimeout(() => {
          window.dispatchEvent(new Event("permissions-updated"));
        }, 0);

        if (data.user.role_slug === "reseller") {
            navigate("/reseller/dashboard");
        } 
        else if (data.user.role_slug === "superadmin" || data.user.role_slug === "admin" || data.user.role_slug === "apiuser") {
            navigate("/dashboard");
        }

        // navigate("/dashboard");
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    return(
        <>
        <div className="section-authentication-login d-flex align-items-center justify-content-center mt-4">
        <div className="row">
          <div className="col-12 col-lg-8 mx-auto">
            <div className="card radius-15 overflow-hidden">
              <div className="row g-0">
                <div className="col-xl-6">
                  <div className="card-body p-5">
                    <div className="text-center">
                      <img src="assets/images/Logo1.png" width={150} alt="" />
                      {/* <img src="assets/images/logo-icon.png" width={80} alt="" /> */}
                      <h3 className="mt-4 font-weight-bold">Welcome Back</h3>
                    </div>
                    <div className>
                      {/* <div className="d-grid">
                        <a className="btn my-4 shadow-sm btn-white" href="javascript:;"> <span className="d-flex justify-content-center align-items-center">
                            <img className="me-2" src="assets/images/icons/search.svg" width={16} alt="Image Description" />
                            <span>Sign in with Google</span>
                          </span>
                        </a> <a href="javascript:;" className="btn btn-facebook"><i className="bx bxl-facebook" />Sign in with Facebook</a>
                      </div> */}
                          {error && (
                            <div className="col-12">
                              <div className="alert alert-danger">{error}</div>
                            </div>
                          )}
                      <div className="login-separater text-center mb-4"> <span>OR SIGN IN WITH EMAIL</span>
                        <hr />
                      </div>
                      <div className="form-body">
                        <form className="row g-3" onSubmit={handleSubmit}>
                          <div className="col-12">
                            <label htmlFor="inputEmailAddress" className="form-label">Email or Mobile</label>
                            <input type="text" className="form-control" name="inputEmailAddress" required id="inputEmailAddress" placeholder="Enter Email or Mobile" />
                          </div>
                          <div className="col-12">
                            <label htmlFor="inputChoosePassword" className="form-label">Enter Password</label>
                            {/* <div className="input-group" id="show_hide_password">
                              <input type="password" className="form-control border-end-0" name="inputChoosePassword" id="inputChoosePassword" required placeholder="Enter Password" /> <a href="#" className="input-group-text bg-transparent"><i className="bx bx-hide" /></a>
                            </div> */}
                            <div className="input-group" id="show_hide_password">
                              <input
                                type={showPassword ? "text" : "password"}
                                className="form-control border-end-0"
                                name="inputChoosePassword"
                                id="inputChoosePassword"
                                required
                                placeholder="Enter Password"
                              />
                              <span
                                className="input-group-text bg-transparent"
                                style={{ cursor: "pointer" }}
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                <i className={`bx ${showPassword ? "bx-show" : "bx-hide"}`} />
                              </span>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-check form-switch">
                              <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                              <label className="form-check-label" htmlFor="flexSwitchCheckChecked">Remember Me</label>
                            </div>
                          </div>
                          <div className="col-md-6 text-end">	
                            {/* <Link to="/forgot-password">Forgot Password ?</Link> */}
                          </div>
                          <div className="col-12">
                            <div className="d-grid">
                              {/* <button type="submit" className="btn btn-primary"><i className="bx bxs-lock-open" />Sign in</button> */}
                              <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? "Signing in..." : <><i className="bx bxs-lock-open" /> Sign in</>}
                              </button>
                            </div>
                          </div>
                          <div className="col-12 text-center">
                            {/* <p>Don't have an account yet? <a href="authentication-register.html">Sign up here</a></p> */}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 bg-login-color d-flex align-items-center justify-content-center">
                  <img src="assets/images/login-images/login-frent-img.jpg" className="img-fluid" alt="..." />
                </div>
              </div>
              {/*end row*/}
            </div>
          </div>
        </div>
      </div>
        </>
    )
}

export default Login